import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bayShoreConfig } from "./data";

export default function BayShorePage() {
  return <CityPageTemplate config={bayShoreConfig} />;
}